import { TableRenderer, TableRenderType } from "./table-renderer";
import { DocumentInfoV2, JsonItem, PickListItem } from "../web-form/web-form.objects";
import _ from "lodash";
import { plainToClass } from "class-transformer";

export class DataViewer {
    propertyName: string;
    displayName: string;
    propertyType: DataViewType;
    pickListId: string;

    tableRenderer: TableRenderer;
    pickLists: JsonItem[];
    documentUploadView: DocumentUploadDataView;

    constructor(propertyName: string, propertyType: DataViewType, displayName: string, pickListId: string = undefined, rootFolderPath: string = undefined) {
        this.propertyName = propertyName;
        this.propertyType = propertyType;
        this.displayName = displayName;
        this.pickListId = pickListId;

        if (this.propertyType == DataViewType.DocumentUpload && rootFolderPath) {
            this.documentUploadView = new DocumentUploadDataView(rootFolderPath);
        }
    }

    initialize(pickLists: JsonItem[]) {
        this.pickLists = pickLists;
        this.tableRenderer = new TableRenderer(this.pickLists);
    }

    getDocuments(obj:any): void {
        let rawVal = _.get(obj, this.propertyName);
        this.documentUploadView.getDocuments(rawVal);
    }

    getDisplayValue(obj: any): string {
        let rawVal = _.get(obj, this.propertyName);

        if (this.propertyType == DataViewType.String) {
            return rawVal;
        }
        else if (this.propertyType == DataViewType.MultilineString) {
            let regex: RegExp = /(\n|\r|\r\n)/g;
            let strVal = <string>rawVal;
            strVal = strVal.replace(regex, "<br/>");
            return strVal;
        }
        else if (this.propertyType == DataViewType.Number) {
            return rawVal;
        }
        else if (this.propertyType == DataViewType.PipePathSeparatedIds) {
            return this.tableRenderer.renderDisplay(rawVal, TableRenderType.PipePathSeparatedIds, this.pickListId);
        }
        else if (this.propertyType == DataViewType.PipePathSeparatedBullets) {
            return this.tableRenderer.renderDisplay(rawVal, TableRenderType.PipePathSeparatedBullets, this.pickListId);
        }
        else if (this.propertyType == DataViewType.NumberId) {
            return this.tableRenderer.renderDisplay(rawVal, TableRenderType.Number, this.pickListId);
        }
        else if (this.propertyType == DataViewType.Boolean) {
            if (rawVal) {
                return "Yes";
            }
            else {
                return "No";
            }
        }
        else if (this.propertyType == DataViewType.Date) {
            return this.tableRenderer.renderDate(rawVal);
        }
        else if (this.propertyType == DataViewType.DocumentUpload) {
            return this.documentUploadView.generateHtml();
        }

        return ""
    }
}

export enum DataViewType {
    String,
    MultilineString,
    Number,
    NumberId,
    PipePathSeparatedIds,
    PipePathSeparatedBullets,
    Boolean,
    Date,
    DocumentUpload,
}

class DocumentUploadDataView {
    uniqueId: string;
    rootFolderPath: string;

    getFilesRoute: string = "/api/upload-service/get-files";
    downloadFileRoute: string = "/api/upload-service/download-file";
    currentDocuments: DocumentInfoV2[];
    constructor(rootFolderPath: string) {
        this.uniqueId = crypto.randomUUID();
        this.currentDocuments = [];
        this.rootFolderPath = rootFolderPath;
    }

    generateHtml(): string {
        let html = `
            <div id="file-upload-${this.uniqueId}" class="file-upload-container">
                <div class="file-upload-loading">
                    <div class="font-size14 mb-1">Loading</div>
                    <div class="">
                        <div class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="file-upload-gallery d-none">
                    
                </div>
                <div id="file-upload-${this.uniqueId}-collapse" class="file-view-container collapse">
                    <div class="my-2">
                        <button data-toggle="collapse" href="#file-upload-${this.uniqueId}-collapse" class="butn px-3 py-2"><span><i class="fa-solid fa-xmark pr-1"></i> Hide</span></button>
                    </div>
                    <iframe class="file-view-iframe" src="" style="width: 100%; height: 500px;" frameborder="0" allowfullscreen="true">
                    </iframe>
                </div>
            </div>
        `
        return html;
    }

    private showLoading(isLoading: boolean = true): void {
        let container = $(`#file-upload-${this.uniqueId}`);
        let loadingBlock = container.find(".file-upload-loading");
        let galleryBlock = container.find(".file-upload-gallery");

        if (isLoading) {
            loadingBlock.removeClass("d-none");
            galleryBlock.addClass("d-none");
        }
        else {
            loadingBlock.addClass("d-none");
            galleryBlock.removeClass("d-none");
        }
    }

    async getDocuments(docIds: string) {
        this.currentDocuments = [];

        this.showLoading();

        let docIdArr: string[] = [];
        if (docIds) {
            docIdArr = docIds.split("|");
        }

        if (docIdArr.length > 0) {
            let result = await this.getCurrentDocuments(docIdArr);
            if (result["items"]) {
                this.currentDocuments = plainToClass(DocumentInfoV2, <DocumentInfoV2[]>result["items"]);
            }
        }

        this.updateGallery();
        this.showLoading(false);

    }

    private async getCurrentDocuments(docIdArr: string[]) {
        let result: any;

        let requestBody = {
            rootFolderPath: this.rootFolderPath,
            uuidArray: docIdArr
        }

        try {
            result = await $.ajax(this.getFilesRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(requestBody),
                contentType: "application/json; charset=utf-8"
            });

            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    private updateGallery() {
        let content = "";
        // Add Content for Each File
        for (let i = 0; i < this.currentDocuments.length; i++) {
            let doc = this.currentDocuments[i];
            // Add logic to determine UUID
            let filePathArr = doc.id.split(`.`);
            let fileType = filePathArr.pop();
            if (fileType) {
                let icon = `<i class="${doc.icon}"></i>`

                let viewBtn = "";
                if (fileType.toLowerCase() == "pdf") {
                    viewBtn = `
                        <button class="butn px-3 py-2 mr-2 file-upload-view-btn" data-index="${i}"><span><i class="fa-solid fa-magnifying-glass"></i></span></button>
                    `
                };


                let encodedId = encodeURI(doc.id);
                let downloadBtn = `
                    <a href="${this.downloadFileRoute}?filePath=${encodedId}" class="butn px-3 py-2 mr-2 file-upload-download-btn" download="${doc.text}"><span><i class="fa-solid fa-file-arrow-down"></i></span></a>
                `;


                let btnGallery = `
                    <div class="d-flex">
                        ${viewBtn}
                        ${downloadBtn}
                    </div>
                `

                let galleryItem = `
                    <div class="gallery-item">
                        <div class="col-12">
                            <div class="header-text">
                                <div class="text-decoration-none d-flex align-items-center">
                                    <div class="pr-3">
                                        ${icon}
                                    </div>
                                    <div class="expand-text pr-3">
                                        ${doc.text}
                                    </div>
                                    <div class="ml-auto">
                                        ${btnGallery}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                content += galleryItem;
            }
        }

        let container = $(`#file-upload-${this.uniqueId}`);
        let galleryBlock = container.find(".file-upload-gallery");

        galleryBlock.empty().html(content);

        let documentViewer = this;
        galleryBlock.find(".file-upload-view-btn").on("click", function () {
            let index = $(this).data("index");
            let parsedIndex = parseInt(index);
            if (parsedIndex != NaN) {
                let foundDoc = documentViewer.currentDocuments[parsedIndex];
                if (foundDoc) {
                    let iframe = container.find("iframe");
                    iframe.attr("src", foundDoc.link);
                    let collapseBlock = container.find(".file-view-container");
                    collapseBlock.collapse("show");
                }
            }
        });
    }
}